import * as React from "react";
import { Icon } from "../Icon/icon";

interface CurrentCalendarProps {
  url: string;
  headline: string;
  startdate: string;
  spanDate: string;
  stopday: string;
  tagList: string[];
  address: string;
  isInEditMode?: boolean;
  datetimeAttr: string;
}

export const CurrentCalendar: React.SFC<CurrentCalendarProps> = (props) => (
  <a href={props.url} className="current-calendar__container">
    <article>
      <time dateTime={props.datetimeAttr}>
        {props.spanDate} {props.startdate}
      </time>
      <div className="current-calendar__time-border" />
      <h2>{props.headline}</h2>

      <div className="current-calendar__footer">
        <div className="current-calendar__tag-list">
          {" "}
          {props.tagList.map((tag) => (
            <div key={tag} className="current-calendar__tag-item text-micro">
              {tag}
            </div>
          ))}
        </div>

        <div className="current-calendar__address-container">
          <Icon
            iconType="fontawesome/map-marker-alt-solid"
            isAriaHidden={false}
            ariaLabel="Adress"
          />
          <div className="current-calendar__address text-micro">
            {props.address}
          </div>
        </div>
      </div>
    </article>
  </a>
);
